import appGlobalScript from 'D:/BuildAgent1/work/344d8854ee1f0d39/src/assets/scripts/cartFunctionsV2.js';
export const globalScripts = appGlobalScript;
